import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-517f4b0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"inline-flex","align-items":"center"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "级联更新频率", -1))
const _hoisted_3 = { class: "button-group" }

import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { DEFAULT_SETTING } from '@/views/dashboard/setting/version-update/_components/cascade-setting/cascade-setting.service'
import TaskTimeEdit from '@/views/dashboard/_components/task-time/task-time-edit.vue'
import { ElMessage } from 'element-plus'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { PolicyCommonService, SaveSettingsReq } from '@/views/dashboard/policy/policy-common.service'
import { deserialize } from '@/utils/tool'
import { SettingsRes } from '@/views/dashboard/policy/software-disabled-edit/software-disabled-edit.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'setting-dialog',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'success'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const { t } = useI18n()
const injector = useReflectiveInjector([PolicyCommonService])
const policyCommon = injector.get(PolicyCommonService)
const formNode = ref()
const formData = ref({
  name: t('cascadeUpdateSetting.policyName'),
  group_ids: [-1],
  bind_mode: 0,
  device_ids: [] as string[],
  strategy: JSON.parse(JSON.stringify(DEFAULT_SETTING)),
} as SettingsRes)

function updateData() {
  policyCommon.getByType({
    strategy_type: PolicyType.system_cascade_update,
    type: PolicySettingType.system_cascade_update,
  }).then(res => {
    if (!res?.data) return
    res.data.strategy = deserialize(res.data.strategy)
    formData.value = res.data as any
  })
}

async function handleConfirm() {
  if (!(await checkBeforeSubmit())) {
    return
  }

  policyCommon.saveSettings({
    ...formData.value,
    strategy: JSON.stringify(formData.value.strategy),
    type: PolicySettingType.system_cascade_update,
    strategy_type: PolicyType.system_cascade_update,
  } as SaveSettingsReq).then(() => {
    emits('success')
    ElMessage.success(t('cascadeUpdateSetting.saveSuccess'))
    handleClose()
  })
}

async function checkBeforeSubmit() {
  if (!(await formNode.value.validate().catch(() => false))) {
    return false
  }

  return true
}

function handleClose() {
  emits('update:modelValue', false)
}

function resetForm() {
  formNode.value && formNode.value.resetFields()
}

watch(() => props.modelValue, (value) => {
  if (value) {
    updateData()
  } else {
    resetForm()
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    "custom-class": "setting-dialog-custom-wrap",
    title: _ctx.$t('cascadeUpdateSetting.dialogTitle'),
    "model-value": __props.modelValue,
    "show-close": "",
    width: 600,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formNode",
        ref: formNode,
        model: formData.value,
        "label-width": 120,
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode("  "),
                _createVNode(_component_el_tooltip, {
                  placement: "top-start",
                  effect: "light",
                  content: "上级更新系统版本后，本级将根据更新频率自动拉取更新数据"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", null, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "assets/icons/info-gray",
                        monochrome: ""
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                size: "small",
                modelValue: formData.value.strategy.frequency,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.strategy.frequency) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (formData.value.strategy.regular_tasks = [..._unref(DEFAULT_SETTING).regular_tasks]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    type: 1,
                    label: _ctx.$t('cascadeUpdateSetting.freqDaily'),
                    value: 1
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    type: 2,
                    label: _ctx.$t('cascadeUpdateSetting.freqWeekly'),
                    value: 2
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    type: 3,
                    label: _ctx.$t('cascadeUpdateSetting.freqMonthly'),
                    value: 3
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('cascadeUpdateSetting.execTimeLabel')
          }, {
            default: _withCtx(() => [
              _createVNode(TaskTimeEdit, {
                "main-switch": "",
                modelValue: formData.value.strategy.regular_tasks,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.strategy.regular_tasks) = $event)),
                "mix-type": formData.value.strategy.frequency,
                "default-end-min": 23 * 60 + 50
              }, null, 8, ["modelValue", "mix-type"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          plain: "",
          onClick: handleClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})